// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  min-height: calc(100% - 20px);
  display: flex;
  flex-direction: column;
  padding: 10px;
}
.container .title {
  margin: 10px auto;
}
.container .spacer {
  flex: 1 1 auto;
}
.container .mat-mdc-raised-button {
  width: 100%;
  border-radius: 0;
  margin: 10px auto;
}
.container .mat-mdc-form-field {
  width: 100%;
}
.container input {
  text-transform: uppercase;
}
.container .field-icon {
  color: #757575;
}

.smart-captcha {
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/view/page/subscription/subscription.component.scss"],"names":[],"mappings":"AAAA;EACI,6BAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AACJ;AAAI;EACI,iBAAA;AAER;AAAI;EACI,cAAA;AAER;AAAI;EACI,WAAA;EACA,gBAAA;EACA,iBAAA;AAER;AAAI;EACI,WAAA;AAER;AAAI;EACI,yBAAA;AAER;AAAI;EACI,cAAA;AAER;;AAEA;EACI,mBAAA;AACJ","sourcesContent":[".container {\n    min-height: calc(100% - 20px);\n    display: flex;\n    flex-direction: column;\n    padding: 10px;\n    .title {\n        margin: 10px auto;\n    }\n    .spacer {\n        flex: 1 1 auto;\n    }\n    .mat-mdc-raised-button {\n        width: 100%;\n        border-radius: 0;\n        margin: 10px auto;\n    }\n    .mat-mdc-form-field {\n        width: 100%;\n    }\n    input {\n        text-transform: uppercase;\n    }\n    .field-icon {\n        color: #757575;\n    }\n}\n\n.smart-captcha {\n    margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
